import React, { useState } from "react";
import styled from "styled-components";
import { Input, Button, message, Tooltip } from "antd";
import { CopyOutlined, CheckOutlined } from "@ant-design/icons";

const CopyField = ({
  value,
  placeholder = "Copy to clipboard",
  size = "large",
  ...props
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      message.success("Copied to clipboard!");

      // Reset copied state after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy:", error);
      message.error("Failed to copy to clipboard");
    }
  };

  return (
    <CopyFieldContainer>
      <StyledInput
        value={value}
        placeholder={placeholder}
        size={size}
        readOnly
        {...props}
      />
      <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
        <CopyButton
          type="primary"
          icon={copied ? <CheckOutlined /> : <CopyOutlined />}
          onClick={handleCopy}
          size={size}
          copied={copied}
        />
      </Tooltip>
    </CopyFieldContainer>
  );
};

const CopyFieldContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const StyledInput = styled(Input)`
  flex: 1;

  .ant-input {
    background-color: var(--color-bg-secondary);
    border-color: var(--color-border-light);
    color: var(--color-text);

    &:focus {
      border-color: var(--color-primary);
      box-shadow: 0 0 0 2px rgba(44, 95, 45, 0.1);
    }
  }
`;

const CopyButton = styled(Button)`
  background: ${(props) => (props.copied ? "#52c41a" : "var(--color-primary)")};
  border-color: ${(props) =>
    props.copied ? "#52c41a" : "var(--color-primary)"};

  &:hover {
    background: ${(props) =>
      props.copied ? "#73d13d" : "var(--color-primary-light)"};
    border-color: ${(props) =>
      props.copied ? "#73d13d" : "var(--color-primary-light)"};
  }
`;

export default CopyField;
